import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import "react-image-crop/dist/ReactCrop.css"
import rotateLeftImg from "images/crop_rotation_left-20x23.png"
import rotateRightImg from "images/crop_rotation_right-20x23.png"
import loadingImg from "images/icon/yellow_loading-40x40.gif"
import ReactCrop from "react-image-crop"
import { FooterStateActions } from "store/actionCreators"

export default function ImgCropperModal({
  srcImg,
  visible,
  croppedImg,
  setCroppedImg,
  onCancel,
  onComplete,
  onError,
}) {
  let imgObj = useRef(null)
  useEffect(() => {
    if (croppedImg) {
      onComplete()
    }
  }, [croppedImg])

  useEffect(() => {
    if (visible) {
      FooterStateActions.updateFooterState({
        visible: false,
      })
    }
    return () => {
      FooterStateActions.updateFooterState({
        visible: true,
      })
    }
  }, [visible])

  const [currCropedImg, setCurrCropedImg] = useState(null)
  const [crop, setCrop] = useState({ unit: "%", width: 100, aspect: 10 / 10 })
  const [displayImg, setDisplayImg] = useState(null)
  const [playLoading, setPlayLoading] = useState(false)

  useEffect(() => {
    if (srcImg) {
      setCroppedImg(null)
      let reader = new FileReader()
      reader.onloadend = (event) => {
        event.preventDefault()
        setDisplayImg(reader.result)
      }
      reader.readAsDataURL(srcImg)
    }
  }, [srcImg])
  let handleCloseModal = (e) => {
    onCancel()
  }

  let handleRotateLeft = async (e) => {
    setPlayLoading(true)
    // import('jimp/es').then(async (module)=>{
    // 	const Jimp = module.default;
    // 	let img = await Jimp.read({
    // 	  url: displayImg,
    // 	  headers: {}
    // 	});
    // 	let rotatedImg = await img.rotate(90);
    // 	let base64Img = await rotatedImg.getBase64Async(Jimp.AUTO)
    // 	setDisplayImg(base64Img);
    // 	setCrop({ unit: '%', width: 100, aspect: 10 / 10 , keepSelection :true});
    // 	setPlayLoading(false);
    // }).catch((e)=>{console.log(e); setPlayLoading(false);})
  }

  let handleRotateRight = async (e) => {
    setPlayLoading(true)
    // import('jimp/es').then(async (module)=>{
    // 	const Jimp = module.default;
    // 	let img = await Jimp.read({
    // 		url: displayImg,
    // 		headers: {}
    // 	});
    // 	let rotatedImg = await img.rotate(-90)
    // 	let base64Img = await rotatedImg.getBase64Async(Jimp.AUTO)
    // 	setDisplayImg(base64Img);
    // 	setCrop({ unit: '%', width: 100, aspect: 10 / 10, minWidth:100 });
    // 	setPlayLoading(false);
    // }).catch((e)=>{console.log(e); setPlayLoading(false);})
  }

  let handleImageLoad = (image) => {
    imgObj.current = image
  }

  let handleCompleteCrop = async (newCropImg) => {
    try {
      let croppedImg = await getCroppedImg(
        imgObj.current,
        newCropImg,
        `${new Date().getTime()}.jpg`
      )

      setCurrCropedImg(croppedImg)
    } catch (err) {
      console.log("handle complete crop")
      console.log(err)
    }
  }

  let getCroppedImg = (image, crop, fileName) => {
    try {
      // As Base64 string
      // const base64Image = canvas.toDataURL('image/jpeg');

      // As a blob
      return new Promise((resolve, reject) => {
        try {
          const newImage = new Image()
          newImage.crossOrigin = "anonymous"
          newImage.onload = () => {
            const canvas = document.createElement("canvas")
            const scaleX = image.naturalWidth / image.width
            const scaleY = image.naturalHeight / image.height
            canvas.width = crop.width * scaleX
            canvas.height = crop.height * scaleY
            const ctx = canvas.getContext("2d")

            ctx.drawImage(
              newImage,
              crop.x * scaleX,
              crop.y * scaleY,
              crop.width * scaleX,
              crop.height * scaleY,
              0,
              0,
              crop.width * scaleX,
              crop.height * scaleY
            )

            // TODO : blob rarely returns null
            // check https://stackoverflow.com/questions/67710162/canvas-toblob-giving-null-sometimes
            ctx.canvas.toBlob(
              (blob) => {
                try {
                  blob.name = fileName
                  blob.lastModifiedDate = new Date().getTime()
                  resolve(blob)
                } catch (err) {
                  console.log("toBlob")
                  console.log(err)
                  if (onError) {
                    onError({
                      error_code: "PROCESS_FAIL",
                      detail_code: "IMG_NOT_LOADED",
                    })
                  }
                }
              },
              "image/jpeg",
              1
            )
          }

          newImage.src = image.src
        } catch (err) {
          console.log("inside promise catch")
          console.log(err)
        }
      })
    } catch (err) {
      console.log("getCroppedImg err")
      console.log(err)
    }
  }
  let handleExportCroppedImg = async (e) => {
    try {
      if (setCroppedImg) {
        setCroppedImg(currCropedImg)
      }
      // onComplete();
    } catch (err) {
      console.log("handleExportCroppedImg")
      console.log(err)
    }
  }
  return (
    <>
      {visible === true ? (
        <ModalWrapper>
          <ModalBackground>
            {playLoading === true ? (
              <LoadingIconWrapper>
                <img src={loadingImg} alt={"loading in progress"} />
              </LoadingIconWrapper>
            ) : (
              <>
                {displayImg && (
                  <ImgWrapper>
                    <ReactCrop
                      src={displayImg}
                      crop={crop}
                      onChange={(newCrop) => setCrop(newCrop)}
                      onComplete={(c) => {
                        handleCompleteCrop(c)
                      }}
                      onImageLoaded={(image) => {
                        handleImageLoad(image)
                      }}
                    />
                  </ImgWrapper>
                )}
                <ModalFooter>
                  <CloseBtn onClick={handleCloseModal}>취소</CloseBtn>
                  <RotateLeftBtn></RotateLeftBtn>
                  <RotateRightBtn></RotateRightBtn>
                  <UploadBtn onClick={handleExportCroppedImg}>업로드</UploadBtn>
                </ModalFooter>
              </>
            )}
          </ModalBackground>
        </ModalWrapper>
      ) : null}
    </>
  )
} //<img src={rotateLeftImg} alt={'rotate left button'}/>
//<img src={rotateRightImg} alt={'rotate right button'}/>
const LoadingIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100vw * (40 / 375));
  height: calc(100vw * (40 / 375));
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 10;
`
const ModalWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 500;
`
const ModalBackground = styled.div`
  background-color: black;
  height: 100vh;
  position: relative;
`
const ModalFooter = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding-bottom: calc(100vw * (30 / 375));
  z-index: 9999;
`
const CloseBtn = styled.div`
  display: inline-block;
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: white;
  padding: 0 calc(100vw * (22 / 375));
`
const UploadBtn = styled.div`
  display: inline-block;
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #ffcf00;
  padding: 0 calc(100vw * (22 / 375));
`

const RotateLeftBtn = styled.div`
  display: inline-block;
  width: calc(100vw * (20 / 375));
  height: calc(100vw * (23 / 375));
`
const RotateRightBtn = styled.div`
  display: inline-block;
  width: calc(100vw * (20 / 375));
  height: calc(100vw * (23 / 375));
`

const ImgWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  height: fit-content;
`
